/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_No_ResultsInputs */

const en_recipes_no_results = /** @type {(inputs: Recipes_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recipes found`)
};

const de_recipes_no_results = /** @type {(inputs: Recipes_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rezepte gefunden`)
};

/**
* | output |
* | --- |
* | "No recipes found" |
*
* @param {Recipes_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_no_results = /** @type {((inputs?: Recipes_No_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_No_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_no_results(inputs)
	return en_recipes_no_results(inputs)
});